import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, palette } from 'theme'
import { color } from 'theme/tokens/color'

const styles: IStyles = {
    wrapper: {
        position: 'relative',
        width: '20%',
        height: '100%',
        backgroundColor: color.bgWhitePrimary,
        border: `1px solid ${color.borderDarkPrimary}`,
        marginLeft: 16,
        borderRadius: 16,
        padding: '16px 16px 32px 16px',

        [mediaCSS.tab]: {
            width: '100%',
            height: '100%',
            marginLeft: 0,
            border: 0,
            borderRadius: 0,
        },
    },
    unselected: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: 16,
        right: 16,
        textAlign: 'center',
    },
    captionWrapper: {
        textAlign: 'center',
        marginBottom: 24,
    },
    deviceName: {
        color: palette.brandBlue,
    },
    caption: {
        marginBottom: 8,
    },
    editButton: {
        width: '100%',
    },
    cancelButtonWrapper: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        borderTop: color.borderDarkPrimary,
        padding: 16,
    },
    cancelButton: {
        width: '100%',
    },
}

addStyles(styles)

export default styles
